<app-chart-form-creation
  (closeDialog)="createNewMetricGroup($event)"
  *ngIf="isPopupOpen">
</app-chart-form-creation>

<div #tooltipContainer style="position: absolute; top: 0; bottom: 0; right: 0; left: 0;"></div>

<div #chartContainer class="relativePageContainer">
  <div [ngClass]="isWidget || dashboardService.userMetricGroups.length === 0? '' : 'dx-card'"
       style="flex: 1 1; display: flex; flex-direction: column; margin: 15px;">
    <div [ngClass]="dashboardService.isChartDrawerOpen? '' : 'noShadowOverlay'"
         style="height: 100%; display: flex; flex-direction: column; overflow: hidden">
      <dx-drawer
        [style.opacity]="(!!dashboardService.userMetricGroups && !loadingChartInfo && !!userMetricGroup)? 1 : 0"
        #drawerComponent
        (onInitialized)="subscribeToWindowResize()"
        (openedChange)="loadDrawerInfo($event);"
        [(opened)]="dashboardService.isChartDrawerOpen"
        [className]="'drawerParent'"
        [closeOnOutsideClick]="false"
        [height]="'100%'"
        [openedStateMode]="'overlap'"
        [position]="'right'"
        [revealMode]="'slide'"
        template="template">

        <!--   INSIDE THE DRAWER     -->
        <!--   INSIDE THE DRAWER     -->
        <!--   INSIDE THE DRAWER     -->
        <!--   INSIDE THE DRAWER     -->

        <div *dxTemplate="let data of 'template'"
             [style.width.px]="setWidthOfDrawerPx()"
             class="chartEditFormContainer">

          <div class="drawerTitleWrapper">
            <h2>{{ "CHART_CREATION.TITLE_DETAIL" | translate }}</h2>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
              <dx-button (onClick)="formDrawerComponent.saveChanges(true); formDrawerComponent.editMode = false;"
                         *ngIf="formDrawerComponent.editMode"
                         [disabled]="!formDrawerComponent.isFormValid" [type]="'default'" icon="save"
                         text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
              <dx-button (onClick)="formDrawerComponent.saveChanges(false); formDrawerComponent.editMode = false;"
                         *ngIf="formDrawerComponent.editMode"
                         [type]="'normal'" [stylingMode]="'contained'" icon="revert" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
              <dx-button (onClick)="formDrawerComponent.saveChanges(false); drawerComponent.instance.hide()"
                         [type]="'default'" [width]="30" icon="close"></dx-button>
            </div>
          </div>

          <app-chart-form-edit
            #formDrawerComponent
            (drawerClosed)="saveChanges($event); drawerComponent.instance.hide()"
            [userMetricGroup]="userMetricGroup">
          </app-chart-form-edit>

        </div>

        <!--   OUTSIDE THE DRAWER     -->
        <!--   OUTSIDE THE DRAWER     -->
        <!--   OUTSIDE THE DRAWER     -->
        <!--   OUTSIDE THE DRAWER     -->

        <div class="multiChartContainer" [style.padding-bottom.px]="isWidget? 0 : 15 ">

          <dx-chart
            *ngIf="!loadingChartInfo"
            style="height: 840px"
            #chartComponent
            (onDone)="getMetricColor($event);"
            (onLegendClick)="onLegendClick($event)"
            (onZoomEnd)="handleZoom($event);"
            (onTooltipShown)="hideOutsideTooltip($event)"
            [customizePoint]="customizeOutsidePoint"
            [adjustOnZoom]="false"
            [dataSource]="chartData"
            [autoHidePointMarkers]="false"
            [redrawOnResize]="true"
            [resizePanesOnZoom]="false"
            [stickyHovering]="true"
            [synchronizeMultiAxes]="true">
            <dxi-series
              *ngFor="let metric of userMetricGroup?.metrics; trackBy: trackByFn"
              [axis]="getSeriesAxis(metric)"
              [color]="metric.color"
              [hoverMode]="'nearestPoint'"
              [name]="getSeriesName(metric)"
              [stack]="metric.alias!"
              [tag]="metric"
              [valueField]="metric.alias!"
              [visible]="metric.isVisible || false"
              [width]="3"
              [type]="chartTypesEnumWrapper[metric.chartType!]">
              <dxo-point
                [size]="0"
                hoverMode="allArgumentPoints">
                <dxo-hover-style
                  [color]="metric.color"
                  [size]="2">
                </dxo-hover-style>
              </dxo-point>
            </dxi-series>
            <dxo-data-prepare-settings
              [convertToAxisDataType]="false"
              [sortingMethod]="false"
              [checkTypeForAllData]="false">
            </dxo-data-prepare-settings>
            <dxo-common-series-settings
              [argumentField]="'ts'"
              [hoverMode]="'includePoints'"
              [ignoreEmptyPoints]="true">
            </dxo-common-series-settings>
            <dxi-value-axis
              *ngFor="let valueAxis of valueAxisList; index as idx"
              [axisDivisionFactor]="60"
              [endOnTick]="true"
              [name]="valueAxis"
              [valueType]="valueAxis === booleanAxisUnit ? 'string' : 'numeric'"
              [position]="idx % 2 === 0? 'left' : 'right'"
              [type]="valueAxis === booleanAxisUnit ? 'discrete' : 'continuous'"
              [categories]="valueAxis === booleanAxisUnit ? booleanAxisCategories : emptyArray"
              [visible]="false"
              discreteAxisDivisionMode="crossLabels">
              <dxo-grid
                [opacity]="0.3">
              </dxo-grid>
              <dxo-label [visible]="!hiddenAxes.has(valueAxis) && !appService.isSmallScreen()">
                <dxo-font [size]="10"></dxo-font>
              </dxo-label>
              <dxo-title [text]="hiddenAxes.has(valueAxis) ? '' : valueAxis" [margin]="4">
                <dxo-font [size]="!hiddenAxes.has(valueAxis) && !appService.isSmallScreen() ? 14 : 0"></dxo-font>
              </dxo-title>
              <dxo-tick [shift]="-3" [visible]="!hiddenAxes.has(valueAxis) && !appService.isSmallScreen()"></dxo-tick>
            </dxi-value-axis>
            <dxo-argument-axis
              [label]="argAxisLabel"
              [tick]="argAxisTick"
              [visible]="!isWidget"
              [visualRange]="visualRangeX"
              aggregatedPointsPosition="betweenTicks"
              argumentType="datetime">
            </dxo-argument-axis>
            <dxo-legend
              [visible]="!isWidget"
              horizontalAlignment="center"
              itemTextPosition="right"
              verticalAlignment="bottom">
            </dxo-legend>
            <dxo-crosshair
              [color]="cssColorLabel"
              [enabled]="true"
              [horizontalLine]="false">
              <dxo-label [visible]="true"></dxo-label>
            </dxo-crosshair>
            <dxo-tooltip
              [arrowLength]="0"
              [color]="cssColorMainBg"
              [container]="tooltipContainer"
              [contentTemplate]="'content'"
              [cornerRadius]="4"
              [enabled]="!dashboardService.isChartDrawerOpen"
              [location]="'edge'"
              [opacity]="0.65"
              [position]="'top'"
              [shadow]="tooltipShadow"
              [shared]="true"
              [showMode]="'always'"
              [zIndex]="200"></dxo-tooltip>
            <dxo-zoom-and-pan
              [allowMouseWheel]="false"
              [dragBoxStyle]="dragBoxStyle"
              [dragToZoom]="true"
              argumentAxis="both"
              panKey="ctrl"
              valueAxis="both">
            </dxo-zoom-and-pan>
            <div *dxTemplate="let info of 'content'" class="state-tooltip">
              <span [innerHTML]="composeChartTooltip(info)"></span>
            </div>
          </dx-chart>

          <div [style.height.px]="!isWidget? 120 : 112">
            <dx-range-selector
              *ngIf="!loadingChartInfo"
              #chartSliderComponent
              [style.opacity]="loadingChartInfo? 0 : 1"
              (onInitialized)="chartIsZoomedX = false;chartIsZoomedY = false"
              (onValueChanged)="onRangeSelectorValueChanged($event)"
              [dataSource]="!isWidget? chartData : []"
              [selectedRangeColor]="cssColorPrimary"
              [value]="visualRangeX"
              style="width: 100%;">
              <dxo-size [height]="!isWidget? 120 : 112"></dxo-size>
              <dxo-margin [left]="10" [right]="10"></dxo-margin>
              <dxo-behavior [animationEnabled]="false" [snapToTicks]="false" valueChangeMode="onHandleMove"></dxo-behavior>
              <dxo-chart *ngIf="!isWidget" palette="Harmony Light">
                <dxi-series
                  *ngFor="let metric of userMetricGroup?.metrics; trackBy: trackByFn"
                  [axis]="getSeriesAxis(metric)"
                  [color]="metric.color"
                  [name]="getSeriesName(metric)"
                  [stack]="metric.alias!"
                  [tag]="metric"
                  [valueField]="metric.alias!"
                  [width]="3"
                  [visible]="metric.isVisible || false"
                  [type]="chartTypesEnumWrapper[metric.chartType!]">
                </dxi-series>
                <dxo-common-series-settings
                  [argumentField]="'ts'"
                  [hoverMode]="'includePoints'"
                  [ignoreEmptyPoints]="true">
                </dxo-common-series-settings>
                <dxi-value-axis
                  *ngFor="let valueAxis of valueAxisList; index as idx"
                  [axisDivisionFactor]="60"
                  [endOnTick]="true"
                  [name]="valueAxis"
                  [valueType]="valueAxis === booleanAxisUnit ? 'string' : 'numeric'"
                  [position]="idx % 2 === 0? 'left' : 'right'"
                  [categories]="valueAxis === booleanAxisUnit ? booleanAxisCategories : emptyArray"
                  [type]="valueAxis === booleanAxisUnit ? 'discrete' : 'continuous'"
                  discreteAxisDivisionMode="crossLabels">
                  <dxo-title [text]="valueAxis"></dxo-title>
                </dxi-value-axis>
              </dxo-chart>
              <dxo-scale
                *ngIf="!!userMetricGroup"
                [endValue]="userMetricGroup.endDate"
                [startValue]="userMetricGroup.startDate"
                valueType="datetime">
                <dxo-minor-tick
                  [visible]="false">
                </dxo-minor-tick>
              </dxo-scale>
              <dxo-slider-marker [color]="cssColorPrimary"
                                 [format]="'shortDateShortTime'"></dxo-slider-marker>
            </dx-range-selector>
          </div>


          <dx-button
            #resetZoomButton
            [focusStateEnabled]="false"
            (onClick)="resetZoom(chartComponent)"
            [elementAttr]="{class:'outlinedRedButton, ketonFab'}"
            [height]="35"
            [stylingMode]="'contained'"
            [title]="'Reset zoom'"
            [visible]="false"
            [width]="35"
            class="raised-button"
            hint="{{'BUTTONS.HINTS.DEZOOM' | translate}}"
            type="default">
            <i class="vr-ic_fluent_zoom_out_24_regular"></i>
          </dx-button>


        </div>

      </dx-drawer>
      <div *ngIf="!!dashboardService.userMetricGroups && !loadingChartInfo && !userMetricGroup"
           class="unselectable absoluteFill noChartAvailable"
           style="flex-direction: row">
        <div *ngIf="dashboardService.userMetricGroups.length === 0">
          <h3 style="text-align: center; margin-top: 0;">{{ (dashboardService.isImpersonatingUser() ? "CHART_CREATION.NO_CHART_OTHER_USER" : "CHART_CREATION.CREATE_CHART_INFO") | translate }}</h3>
          <dx-button
            *ngIf="!dashboardService.isImpersonatingUser()"
            (onClick)="this.isPopupOpen = true;"
            [disabled]="loadingChartInfo"
            [elementAttr]="{class:'outlinedRedButton'}"
            [title]="'Crea gruppo'"
            [type]="'default'"
            [width]="'100%'"
            hint="{{'BUTTONS.HINTS.CREATE_METRIC_GROUP' | translate}}">
            <i class="vr-ic_fluent_add_24_regular"></i>
            <span>{{ 'BUTTONS.ADD' | translate }}</span>
          </dx-button>
          <img alt="Keton-logo-inntea-angolo" class="cornerImage" height="600"
               ngSrc="assets/Keton-logo-inntea-angolo.png"
               priority width="600">
        </div>
        <div *ngIf="dashboardService.userMetricGroups.length > 0">
          <h3 style="text-align: center; margin-top: 0;">{{ "CHART_CREATION.SELECT_CHART_INFO" | translate }}</h3>
          <img alt="Keton-logo-inntea-angolo" class="cornerImage" height="600"
               ngSrc="assets/Keton-logo-inntea-angolo.png"
               priority width="600">
        </div>
      </div>
    </div>
  </div>
</div>
